import type { FeatureModule } from '@/shell/registry/types'

const wb = () => import('./SolWorkbench.vue')

export default {
  code: 'solution',
  title: '产研工作台',
  routes: [
    { path: '/product', redirect: '/product/overview' },
    { path: '/product/overview', name: 'overview', component: wb, meta: { tab: 'sol', title: '产研总览' } },
    { path: '/product/goals', name: 'goals', component: wb, meta: { tab: 'sol', title: '项目目标' } },
    { path: '/product/plan', name: 'plan', component: wb, meta: { tab: 'sol', title: '项目计划' } },
    { path: '/product/solutions', name: 'solution', component: wb, meta: { tab: 'sol', title: '解决方案' } },
    { path: '/product/solutions/knowledge', redirect: '/product/solutions' },
    /* 需求管理菜单入口已下线（2026-11-04）：评审能力同时保留在需求详情页；旧 review 链接重定向，避免审批中心历史深链 404。
       需求全景页（ReqReviewWorkbench 详情模式）保留，由需求清单行点击进入。 */
    { path: '/product/requirements/review', redirect: to => ({ path: '/product/requirements', query: to.query.req ? { open: String(to.query.req) } : {} }) },
    { path: '/product/requirements/panorama/:id', name: 'rmReqPanorama', component: wb, meta: { tab: 'sol', title: '需求详情' } },
    { path: '/product/requirements/detail', name: 'reqdetail', component: wb, meta: { tab: 'sol', title: '需求详情' } },
    { path: '/product/dev-plan', name: 'devplan', component: wb, meta: { tab: 'sol', title: '开发方案' } },
    { path: '/product/solutions/library', redirect: '/product/solutions' },
    { path: '/product/requirements', name: 'rmReqs', component: wb, meta: { tab: 'sol', title: '需求清单' } },
    { path: '/product/requirements/detail/:id', name: 'rmReqDetail', component: wb, meta: { tab: 'sol', title: '需求详情' } },
    { path: '/product/features', name: 'rmFeats', component: wb, meta: { tab: 'sol', title: '功能清单' } },
    { path: '/product/test-cases', name: 'rmTests', component: wb, meta: { tab: 'sol', title: '测试用例' } },
  ],
} satisfies FeatureModule
